module.exports = __webpack_public_path__ + "img/responsive.b5a4678c.png";